import React, { useRef,useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/UserProvider";
import dpeService from "../services/rapport-service";
import {
  actifsService,
  sitesSerivces,
  fichiersService,
  classeursService,
  usersService,
  parcellesService,
} from "../services";
import { Actif, Fichier, Classeur, Site, User,Parcelle } from "../interfaces";
import { CLIENT_LINKS, GEXPERTISE_LINKS } from "../utils/SidebarItems";
import { useQuery } from "@tanstack/react-query";
import { Menu } from "primereact/menu";
import { showToast } from "../components";
import ClientsService from "../services/client-service";
import { Tooltip } from "react-tooltip";

import { Dialog } from 'primereact/dialog';
import { useLocation } from "react-router-dom";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../config/awsParams";


const SideBar = () => {
  const menuLeft = useRef<Menu>(null);
  const navigate = useNavigate();
  const { user, client } = useAuth();
  const location = useLocation();
  const currentPath = decodeURIComponent(location.pathname);
  const [showLexique, setShowLexique] = useState(false);

  const isGexpertise = () =>
    user &&
    (user.role.includes("ADMIN_GEXPERTISE") ||
      user.role.includes("ASSISTANT_PROJET"));

  const isClient = () =>
    user &&
    (user.role.includes("MAITRE_ADMIN_CLIENT") ||
      user.role.includes("ADMIN_CLIENT") ||
      user.role.includes("VIEWER_CLIENT") ||
      user.role.includes("EDITEUR_CLIENT"));

    const { data: parcelles } = useQuery<Parcelle[]>({
        queryKey: ["parcelles", client],
        queryFn: async () => {
          if (user.role.includes("ADMIN_GEXPERTISE")) {
            return await parcellesService.getAll();
          } else {
            return await parcellesService.getAll(client?.id);
          }
        },
    });

  const { data: sites } = useQuery<Site[]>({
    queryKey: ["sites", user],
    queryFn: async () => {
      if (isGexpertise()) {
        return await sitesSerivces.getAll();
      } else {
        return await sitesSerivces.getAll(client.id);
      }
    },
    enabled: !!user,
  });
  
  const { data: nb_actifs } = useQuery<number>({
    queryKey: ["nb_actifs", user],
    queryFn: async () => {
      if (isGexpertise()) {
        return await actifsService.getNbActifs(0);
      } else {
        return await actifsService.getNbActifs(client.id);
        
      }
    },
  });

  const { data: nb_rapport } = useQuery<number>({
    queryKey: ["nb_rapport", user],
    queryFn: async () => {
      if (isGexpertise()) {
        return await dpeService.count(0);
      } else {
        return await dpeService.count(client.id);
        
      }
    },
  });

  const { data: fichiers } = useQuery<Fichier[]>({
    queryKey: ["fichiers", user],
    queryFn: async () => {
      if (isGexpertise()) {
        return await fichiersService.getgexbox();
      } else {
        return await fichiersService.getgexbox(client.id);
      }
    },
  });

  const { data: classeurs } = useQuery<Classeur[]>({
    queryKey: ["classeurs", user],
    queryFn: async () => {
      if (isGexpertise()) {
        return await classeursService.getAll();
      } else {
        return await classeursService.getAll(client.id);
      }
    },
  });

  const { data: count_clients } = useQuery<number>({
    queryKey: ["count_clients"],
    queryFn: async () => {
      if (isGexpertise()) {
        return await ClientsService.get_count_all();
      }
    },
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });


  const items_client = [
    {
      label: user ? ` ${user.email}` : "Options",
      items: [
        {
          label: "Mon profile",
          icon: "pi pi-user",
          command: () => {
            navigate("/settings");
            showToast("info", "profile");
          },
        },

       


        {
          label: "Tuto structuration bâtimentaire ",
          icon: "pi pi-book",
         command: () => {
            const response = usersService.tuto_frist({column:"first_time_t3",val:true,id:user.id});
            if (response) {
             
              navigate("/entité-géospatiale");
              navigate(0);
            }
         },
        },
        {
          label: "Tuto qualification documentaire ",
          icon: "pi pi-book",
           command: () => {
            const response = usersService.tuto_frist({column:"first_time_t2",val:true,id:user.id});
            if (response) {
              navigate("/gexbox");
              navigate(0);
            }
          },
        },
        {
          label: "Tuto recherche documentaire",
          icon: "pi pi-book",
           command: () => {
            const response = usersService.tuto_frist({column:"first_time_t1",val:true,id:user.id});
            if (response) {
              navigate("/liste-actifs");
              navigate(0);
            }
          },
        },
        {
          label: "Lexique",
          icon: "pi pi-info-circle",
          command: () => setShowLexique(true),
        },
     

        {
          label: "Se déconnecter",
          icon: "pi pi-fw pi-sign-out",
          command: () => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            navigate("/login");
            showToast("info", "déconnexion");
          },
        },

      ]

    },
  ];

  const items_admin = [
    {
      label: user ? ` ${user.email}` : "Options",
      items: [
        {
          label: "Mon profile",
          icon: "pi pi-user",
          command: () => {
            navigate("/settings");
            showToast("info", "profil");
          },
        },

        {
          label: "Se déconnecter",
          icon: "pi pi-fw pi-sign-out",
          command: () => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            navigate("/login");
            showToast("info", "déconnexion");
          },
        },

     
      ],

    },
  ];










  const imageURL = user?.photo_user
    ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${user?.photo_user}`
    : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`;

  return (
    <>
      <nav className="fixed top-0 z-50 w-full bg-[#3D4A5C] border-b transition-transform  shadow-sm border-gray-200 ">
        <div className="px-3 py-3 lg:px-5 lg:pl-3 ">
          <div className="flex items-center justify-end ">
            <div className="flex items-center ">
              <div className="flex items-center ml-3 ">
                <div className="flex space-x-5 justify-center items-center ">
                  <a
                    href={`/environnement/${client?.id}`}
                    className={` ${
                      client?.id_env_arcgis &&
                      user?.role?.split(".").pop() === "MAITRE_ADMIN_CLIENT"
                        ? null
                        : "pointer-events-none"
                    } flex justify-center items-center  font-bold  px-5 py-2 text-md tracking-wide  bg-white hover:bg-gray-200 rounded-lg  gap-x-2`}
                  >
                    <span className=" text-md font-bold text-gexpertise-100">
                      {client?.nom_env_client != null
                        ? client?.nom_env_client
                        : "Administrateur Gexpertise"}
                    </span>
                    {/* <p className=" text-md font-bold text-gray-500">
                      {client?.nom_env_client != null &&
                        `${client?.id_env_arcgis}`}
                    </p> */}
                  </a>
                  <a
                    data-tooltip-id="tooltip-diagonline"
                    href={client?.url_web}
                    className={` ${
                      client?.url_env ? null : "pointer-events-none "
                    } flex font-bold hover:bg-gray-200  px-5 py-2 text-md tracking-wide text-gray-500   bg-white rounded-lg   gap-x-2`}
                  >
                    <img src="../images/esri_png.png" className="w-6 h-6" id="DiagOnline-tuto"/>
                    Accéder à Cartographie
                  </a>
                  <Tooltip id="tooltip-diagonline" place="bottom">
                    Mes applications cartographiques 
                  </Tooltip>
                
                  <button 
                    data-tooltip-id="profile"
                    type="button"
                    className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 "
                    aria-controls="popup_menu_left"
                    aria-haspopup="true"
                    onClick={(event) =>  menuLeft.current?.toggle(event)}
                  >
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="w-8 h-8 rounded-full"
                      src={imageURL}
                      alt="user photo"
                    />

                                                                 
                  </button>

                  <Menu
                      model={isGexpertise() ? items_admin : items_client}
                      popup
                      ref={menuLeft}
                      id="popup_menu_left"
                      appendTo={document.body}
                      style={{
                        width: '280px',
                        position: 'fixed',
                        top: '0px',
                        left: '0px',
                        zIndex: 1000,
                      }}
                    />
                
              
                  <Tooltip id="profile" place="bottom" >    
                  Mon profil
                  </Tooltip>
                  
                 
                  {showLexique &&
                      (<Dialog header="" visible={showLexique} style={{ width: '100vw' }} onHide={() => {if (!showLexique) return; setShowLexique(false); }}>
                        <h2 style={{ fontSize: "20px", marginBottom: "15px", fontWeight: "bold" }}>
                          Les entités bâtimentaires:
                        </h2> 
                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                          Site :
                        </h3> 
                        <p >Le site correspond à la délimitation foncière des actifs immobiliers, ainsi que de ses composants bâtimentaires.  </p>
                        </div>

                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                          Bâtiment :
                        </h3>
                        <p> Un bâtiment fait référence à tout ouvrage, établissements, maison, immeuble, entrepôt etc… pouvant être localisé à partir d’une ou plusieurs adresses. </p>
                        </div>
                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Niveau :
                        </h3> 
                        <p>Un niveau fait référence à l’étage d’un bâtiment. Cette entité est obligatoire pour la création d’un espace.  </p>
                        </div>

                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Espace :
                        </h3> 
                        <p>Un espace est une composante d’un bâtiment qui peut être composé d’une à plusieurs pièces. Cette entité permet d’associer des informations attributaires dont le niveau d’information s’arrête à un lot de copropriété, une partie commune etc…  </p>
                        </div>

                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Pièce :
                        </h3> 
                        <p>Une pièce correspond à l’entité avec le niveau d’information le plus bas. Il s’agit de la composante bâtimentaire qui définit les espaces. 
                        </p>
                        </div>
                         <br></br>

                        <h2 style={{ fontSize: "20px", marginBottom: "15px", fontWeight: "bold" }}>
                          Les entités juridiques:
                        </h2> 

                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Actif :
                        </h3> 
                        <p>Un actif immobilier est un ensemble de biens fonciers et immobiliers (entités bâtimentaires) exploités de manière à générer des revenus positifs pour un propriétaire. Un actif est immobilier est donc définit et qualifié, à partir d’une ou plusieurs entités bâtimentaires. 
                        </p>
                        </div>
                        <div style={{   display: "flex", gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Unité d’organisation :
                        </h3> 
                        <p>Une unité d’organisation est un ensemble d’entités bâtimentaires dans un actif spécifique. Une unité ne peut donc être composée d’entités bâtimentaires provenant d’actifs différents.
                        </p>


                        </div> 


                        <ol>
                        <li > <p style={{ fontWeight: "bold", display:"inline" }}>    -  Unité d’organisation  </p>  </li>
                        <li> <p style={{ fontWeight: "bold", display:"inline" }}>     -  Unité de destination  </p>  </li>
                        <li> <p style={{ fontWeight: "bold", display:"inline" }}>     -  Unité locative   </p>  </li>
                        <li> <p style={{ fontWeight: "bold", display:"inline" }}>     -  Unité d’occupation   </p>  </li>
                        <li> <p style={{ fontWeight: "bold", display:"inline" }}>     -  Unité volumétrique   </p>  </li>
                        <li> <p style={{ fontWeight: "bold", display:"inline" }}>     -  Unité de copropriété   </p>  </li>
                        </ol>
                       <br></br>


                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Propriétaires :
                        </h3> 
                         <p>Un actif peut être détenu deux types de propriétaire : </p> 
                        
                        </div>
                        <ol>
                        <li > <p style={{ fontWeight: "bold", display:"inline" }}>    - Société :</p> La première est la forme morale. Le cas échéant, une ou plusieurs sociétés peuvent être propriétaires d’un actif </li>
                        <li> <p style={{ fontWeight: "bold", display:"inline" }}>     - Individu :</p> La deuxième est la forme physique. Le cas échéant, un ou plusieurs individus peuvent détenir un actif.  </li>
                        </ol>



                        <h2 style={{ fontSize: "20px", marginBottom: "15px", fontWeight: "bold" }}>
                          Autres entités:
                        </h2> 


                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        GexBox :
                        </h3> 
                        <p>Cet onglet vous permet d’importer vos différents documents immobiliers. Les formats supportés par la GexBox sont les suivants :PDF, DWG ..
                        </p>
                        </div>
                        <div style={{ display: "flex",  gap: "5px" }}>
                        <h3 style={{ fontSize: "1rem", marginBottom: "15px", fontWeight: "bold" }}>
                        Classeur  :
                        </h3> 
                        <p>Un classeur est une entité permettant de qualifier vos documents immobiliers importés dans le système. Plusieurs documents importés (fichier) peuvent être associés à un classeur. <br></br>Sa spécificité réside dans le fait qu’un classeur doit être associé avec les composantes bâtimentaires de vos actifs immobiliers. 
                        </p></div>
                        <br></br><br></br>
                      </Dialog>)
                    }
                
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <aside
        id="logo-sidebar"
        className="fixed top-0 left-0  w-64 h-screen pt-20 transition-transform -translate-x-full bg-white border-r border-gray-200 sm:translate-x-0 "
        aria-label="Sidebar"
      >
        <div className="flex items-center justify-start mb-6">
          <a className="flex ml-2 md:mr-24">
            <img
              src="/images/logo.png"
              className="h-8 mr-2"
              alt="Gexpertise Logo"
            />
            <span className="self-center text-sm font-semibold sm:text-sm whitespace-nowrap ">
              ESPACE DOCUMENTAIRE V1
            </span>
          </a>
        </div>

        <div className="h-full px-3 pb-4  overflow-y-auto bg-white ">
          <ul className="space-y-3 mt-2">
            {isGexpertise() && (
              <>
                {GEXPERTISE_LINKS.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className={`${link.className} ${currentPath === link.href ? "bg-gray-300" : ""}`} data-tooltip-id={`tooltip-${index}`} >
                      <img src={link.imgSrc} />
                      <span
                        className="flex-1 ml-3 font-medium"
                        id="dashboardTuto"
                      >
                      {link.title}
                      </span>
                      {link.showCount && (
                        <span className="inline-flex items-center justify-center px-2   text-sm font-medium text-white bg-red-600  rounded ">
                          {link.title === "Actif"
                            ? nb_actifs
                            : link.title === "GexBox"
                            ? fichiers?.length
                            : link.title === "Classeurs"
                            ? classeurs?.length
                            : link.title === "Environnement Client"
                            ? count_clients ?? 0
                            : link.title === "Arborescence bâtimentaire"
                            ? sites?.length
                            : link.title === "Délimitations foncières"
                            ? parcelles?.length
                            : link.title === "Extraction des données"
                            ? nb_rapport
                            : parcelles?.length }
                        </span>
                      )}
                    </a>
                    <Tooltip id={`tooltip-${index}`} place="top" >
                      {link.bulles}
                    </Tooltip>
                  </li>
                ))}
              </>
            )}
            {isClient() && (
              <>
                {CLIENT_LINKS.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className={`${link.className} ${currentPath === link.href ? "bg-gray-300" : ""}`} data-tooltip-id={`tooltip-${index}`}   >
                      <img src={link.imgSrc} />
                      <span
                        className="flex-1 ml-3 font-medium"
                        id={`dashboardTuto-${index}`}                   
                      >
                        {link.title}
                      </span>
                      {link.showCount && (
                        <span className="inline-flex items-center justify-center px-2   text-sm font-medium text-white bg-red-600  rounded "  >
                          {link.title === "Actif"
                            ? nb_actifs
                            : link.title === "GexBox"
                            ? fichiers?.length
                            : link.title === "Classeurs"
                            ? classeurs?.length
                            : link.title === "Arborescence bâtimentaire"
                            ? sites?.length
                            : link.title === "Délimitations foncières"
                            ? parcelles?.length
                            : link.title === "Extraction des données"
                            ? nb_rapport
                            : parcelles?.length }
                        </span>
                      )}
                    </a>
                    <Tooltip id={`tooltip-${index}`} place="top" >
                      {link.bulles}
                    </Tooltip>
                  </li>
                ))}
              </>
            )}
          </ul>
          
        </div>
       
      </aside>
    
    </>
  );
};

export default SideBar;
